export type RideChatSenderRole = 'driver' | 'customer';

export interface RideChatMessage {
  id: string;
  senderId: string;
  senderRole: RideChatSenderRole;
  text: string;
  createdAt: string;
}

interface RideChatPayload {
  messages: RideChatMessage[];
}

export const parseRideChatNotes = (notes: string | null | undefined): RideChatMessage[] => {
  if (!notes) return [];

  try {
    const parsed = JSON.parse(notes) as RideChatPayload | RideChatMessage[];

    if (Array.isArray(parsed)) {
      return parsed.filter((m): m is RideChatMessage => !!m?.id && !!m?.senderId && !!m?.text);
    }

    if (Array.isArray(parsed?.messages)) {
      return parsed.messages.filter((m): m is RideChatMessage => !!m?.id && !!m?.senderId && !!m?.text);
    }

    return [];
  } catch {
    return [];
  }
};

export const appendRideChatMessage = (
  previousNotes: string | null | undefined,
  message: RideChatMessage,
): string => {
  const existingMessages = parseRideChatNotes(previousNotes);

  const nextMessages = [...existingMessages, message].slice(-100);

  return JSON.stringify({ messages: nextMessages });
};
